import {
  getSpecificWorkflowState,
  getWorkflowState,
} from 'state/workflowSlice';

import { WorkflowType } from 'appConstants';
import { workflowDetour } from 'features/workflow_detour/WorkflowDetour';
import { workflowSpeed } from 'features/workflow_nrt/WorkflowSpeed';
import { workflowOriginDestination } from 'features/workflow_origindestination/WorkflowOriginDestination';
import { workflowPlanning } from 'features/workflow_planning/WorkflowPlanning';
import { workflowQueuing } from 'features/workflow_queuing/WorkflowQueuing';
import { workflowRouteMonitoring } from 'features/workflow_routemonitoring/WorkflowRouteMonitoring';
import { workflowTimeline } from 'features/workflow_timeline/WorkflowTimeline';
import { workflowTravelTime } from 'features/workflow_traveltime/WorkflowTravelTime';

import { ReliesOn } from './NoDataLoadedWarning';

export type WorkflowInfo = {
  switchToState: (fromWorkflow: WorkflowType, state: any) => void;
  dataAvailableReliesOn: ReliesOn[];
};

export const workflowLookup: { [k: string]: WorkflowInfo } = {
  [WorkflowType.Timeline]: workflowTimeline,
  [WorkflowType.Speed]: workflowSpeed,
  [WorkflowType.RouteMonitoring]: workflowRouteMonitoring,
  [WorkflowType.TravelTime]: workflowTravelTime,
  [WorkflowType.Plan]: workflowPlanning,
  [WorkflowType.Queuing]: workflowQueuing,
  [WorkflowType.Detouring]: workflowDetour,
  [WorkflowType.OriginDestination]: workflowOriginDestination,
};

const multidayWorkflows = [
  WorkflowType.TravelTime,
  WorkflowType.Speed,
  WorkflowType.Queuing,
];

export function maybeCarryOverDates(state, fromWorkflow) {
  if (
    [
      WorkflowType.Timeline,
      WorkflowType.Speed,
      WorkflowType.TravelTime,
      WorkflowType.Queuing,
      WorkflowType.RouteMonitoring,
    ].includes(fromWorkflow)
  ) {
    getWorkflowState(state).targetDate = getSpecificWorkflowState(
      state,
      fromWorkflow,
    ).targetDate;
    getWorkflowState(state).comparison = getSpecificWorkflowState(
      state,
      fromWorkflow,
    ).comparison;
    if (multidayWorkflows.includes(state.current)) {
      const workflowState = getSpecificWorkflowState(state, fromWorkflow);
      getWorkflowState(state).targetEndDate = workflowState?.targetEndDate;
      getWorkflowState(state).comparisonEndDate =
        workflowState?.comparisonEndDate;
    }
  }
  if (!multidayWorkflows.includes(state.current)) {
    getWorkflowState(state, true).targetEndDate = undefined;
    getWorkflowState(state, true).comparisonEndDate = undefined;
  }
}

export function maybeCarryOverRouteSelection(state, fromWorkflow) {
  if (
    [
      WorkflowType.TravelTime,
      WorkflowType.Queuing,
      WorkflowType.RouteMonitoring,
      WorkflowType.Speed,
    ].includes(fromWorkflow)
  ) {
    getWorkflowState(state).routeSelection = getSpecificWorkflowState(
      state,
      fromWorkflow,
    ).routeSelection;
    getWorkflowState(state).routeSelectionHistory = getSpecificWorkflowState(
      state,
      fromWorkflow,
    ).routeSelectionHistory;
    getWorkflowState(state).segmentId = getSpecificWorkflowState(
      state,
      fromWorkflow,
    ).segmentId;
  }
}

export function maybeCarryOverSelection(state, fromWorkflow) {
  if ([WorkflowType.Plan, WorkflowType.Speed].includes(fromWorkflow)) {
    getWorkflowState(state).segmentId = getSpecificWorkflowState(
      state,
      fromWorkflow,
    ).segmentId;
  }
}
